/**
 * Affiliations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "@/constants/AppConfig";

// States
const state = {
    etablissementExamens: [],
    etablissementExamen: {}
};

// Getters
const getters = {
    etablissementExamens: state => {
        return state.etablissementExamens
    },

    etablissementExamen: state => {
        return state.etablissementExamen
    }
};

// Actions
const actions = {
    getComplementaryExams(context, payload) {
        function successCallback(response) {
            context.commit('getEtablissementExamensHandler', { etablissementExamens: response.data.examen_prix });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.EtablissementPrice.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getComplementaryExam(context, payload) {
        function successCallback(response) {
            context.commit('getComplementaryExamHandler', { complementaryExam: response.data.examenComplementaire });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Exam.Complementary.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createEtablissementPrice(context, payload) {
        function successCallback(response) {
            if(response.statut){
                Vue.swal(
                    payload.successMessage,
                    '',
                    'success'
                );
            }
           // router.push({ name: 'etablissement-price', params: { price_etablissement: response.data.etablissementPrice.id } });
        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.EtablissementPrice.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createEtablissementPrestationCvs(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'etablissement-prices-list', params: { prestation_etablissement: response.data.etablissementExamen.slug } });
        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');
        let url = AppConfig.apiUrl + apiModel.EtablissementPrestation.Import.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        // makeApiRequest(payload.args, apiModel.EtablissementPrestation.Import, localToken, successCallback, errorCallback, payload.errorMessages,true);
    },

    updateEtablissementExamen(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
           // store.dispatch('findAndRemove', {name: 'etablissementExamen' });
           // router.push({ name: 'etablissement-prestation', params: { etablissementExamen: response.data.etablissementExamen.slug } });

        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.EtablissementPrice.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteEtablissementPrestation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'etablissementExamen' });
            router.push({ name: 'etablissement-prestations' });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.EtablissementPrestation.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getEtablissementExamensHandler(state, { etablissementExamens }) {
        // Update affiliations state
        state.etablissementExamens = etablissementExamens;
    },

    getEtablissementPrestationHandler(state, { etablissementExamen }) {
        // Update affiliation state
        state.etablissementExamen = etablissementExamen;
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}